function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.964 7.134c-.809-.467-1.915-.854-2.865-1.134.95-.28 2.056-.667 2.865-1.134a1 1 0 00-1-1.732c-.809.467-1.697 1.232-2.415 1.914.232-.963.45-2.114.45-3.048a1 1 0 00-2 0c0 .934.218 2.086.45 3.048-.717-.683-1.606-1.447-2.415-1.914a1 1 0 00-1 1.732c.809.467 1.915.854 2.865 1.134-.95.28-2.056.667-2.865 1.134a1 1 0 001 1.732c.809-.467 1.697-1.232 2.415-1.914-.232.963-.45 2.114-.45 3.048a1 1 0 002 0c0-.934-.218-2.086-.45-3.048.717.683 1.606 1.447 2.415 1.914a1 1 0 001-1.732zM7 13.5a1.5 1.5 0 11-3.001-.001A1.5 1.5 0 017 13.5zM0 16L4 0h2L2 16zM15 16l4-16h2l-4 16z"
});

function SvgProcessIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 16",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIcon);
export default __webpack_public_path__ + "static/media/process-icon.5dd65e81fdb7b5eca546a5c74490c614.svg";
export { ForwardRef as ReactComponent };